import { carouselData } from '@/mocks/home';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">精选专题</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            为你精选近期最受关注的高清影视专题，蓝光画质极速播放
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselData.map((item) => (
            <a
              key={item.id}
              href={item.link}
              className="group block rounded-xl overflow-hidden bg-background-100 border border-background-200/60 hover:border-accent-300/40 transition-all duration-300 cursor-pointer"
            >
              <div className="relative overflow-hidden h-[240px] md:h-[280px]">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-3 py-1 rounded-full bg-accent-500/90 text-background-50 text-xs font-medium">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-lg font-heading text-foreground-900 mb-2 group-hover:text-accent-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {item.description}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}